import { RootState } from 'store';
import createResourceListSelectors from 'store/ResourceListSelectors';
import { StateResource, ResourceListSelectors } from 'typings/state';

const selectors: ResourceListSelectors = createResourceListSelectors(
    (state: RootState): StateResource => state.rentalAgency,
);

export default selectors;
